/**
 * ProfilePhase and SessionPhase types plus readiness helpers for AuthLayout gates.
 */
export type ProfilePhase = 'idle' | 'loading' | 'ready' | 'missing' | 'error';
export type SessionPhase = 'idle' | 'loading' | 'ready' | 'error';

export type AppReadiness = {
  authReady: boolean;
  authLoading: boolean;
  profilePhase: ProfilePhase;
  sessionPhase: SessionPhase;
  uid: string | null;
};

export function isProfileReady(phase: ProfilePhase): boolean {
  return phase === 'ready';
}

export function isProfileLoading(phase: ProfilePhase): boolean {
  return phase === 'loading';
}

export function isProfileMissing(phase: ProfilePhase): boolean {
  return phase === 'missing';
}

export function isSessionReady(phase: SessionPhase): boolean {
  return phase === 'ready';
}

export function isSessionLoading(phase: SessionPhase): boolean {
  return phase === 'loading';
}
